import { DownloadOutlined } from '@ant-design/icons';
import useEnforceLoggedIn from '@hooks/useEnforceLoggedIn';
import useFileDownloader from '@hooks/useFileDownloader';
import { NotificationType, showNotification } from '@lib/notification';
import { Button, Col, Row, Space, Spin } from "antd";
import moment from 'moment';
import { useEffect, useState } from 'react';
import ManageFieldsButton from '../manage-fields-button';


const getLastDownloadedFile = (type, dates) => {

    let [result] = dates
        ?.filter((item) =>
            item.type === type
        ).sort((a, b) => moment(b.updatedAt)
            .diff(moment(a.updatedAt)));

    return result;
}

const DownloadBar = ({
    type,
    date,
    fieldsOptons,
    lastDownloadedFile = [],
    ids = [],
    onFilterChange,
    onDownloadSuccess,
    isLoading = false }) => {

    const { user } = useEnforceLoggedIn();

    const [issueIds, setIssueIds] = useState([]);

    const [fieldOptions, setFieldOptions] = useState([]);

    const [downloadDate, setDownloadDate] = useState('');

    const [downloadType, setDownloadType] = useState('');

    const [lastDLFileObj, setLastDLFileObj] = useState<any>({});

    const { downloadFile, error, success } = useFileDownloader();

    const handleNewReleaseDownloadClick = () => {
        let todayDate = moment().format('YYYYMMDD_hhmmss');
        let fileName = `${downloadType}_${downloadDate.replace(/-/g, '')}_${todayDate}.csv`;

        downloadFile(`covr/v1/partner-portal/download`, {
            userId: user.id,
            date: downloadDate,
            issueIds: issueIds,
            type: downloadType,
            fileName: fileName,
        }, fileName);
    }

    const handleFilterChange = (activeElements) => {
        onFilterChange(activeElements);
    }

    useEffect(() => {

        setIssueIds(ids);

        setDownloadDate(date);

        setDownloadType(type);

        setFieldOptions(fieldsOptons)

        setLastDLFileObj(
            getLastDownloadedFile(
                type,
                lastDownloadedFile
            )
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ids, date, type, lastDownloadedFile]);

    useEffect(() => {

        if (success) {
            let message = 'Download Success';
            showNotification(message, NotificationType.SUCCESS);
            onDownloadSuccess(success);
        }

        if (error) {
            let message = 'Error Downloading';
            showNotification(message, NotificationType.ERROR);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, success]);

    return (
        <Spin spinning={isLoading}>

            <Row
                align={`middle`}
                className={`pp-download-bar`}
                justify={`space-between`}
            >
                <Col>

                    {(lastDLFileObj?.name &&
                        lastDLFileObj?.updatedAt) &&
                        <span className={`date`}>
                            Last Downloaded:&nbsp;{moment(lastDLFileObj.updatedAt)
                                .format('YYYY/MM/DD @ hh:mm A')}, {lastDLFileObj.name}<br />
                        </span>
                    }

                </Col>

                <Col>
                    <Space direction={`horizontal`}>

                        <ManageFieldsButton
                            exportableFields={fieldOptions}
                            className={`fields-btn`}
                            onFilterChange={handleFilterChange}
                            type={`link`}
                        />

                        <Button
                            onClick={handleNewReleaseDownloadClick}
                            disabled={issueIds.length === 0}
                            className={`download-btn`}
                            type={`primary`}
                            size={`large`}
                        >
                            Generate File <DownloadOutlined />
                        </Button>

                    </Space>

                </Col>

            </Row>

        </Spin>
    );
};

export default DownloadBar;
